import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import NavigationAnchorRoot from './NavigationAnchorRoot';

NavigationAnchor.propTypes = {
	icon: PropTypes.string,
	label: PropTypes.oneOfType([
		PropTypes.element,
		PropTypes.string,
		PropTypes.any,
	]),
	linkTo: PropTypes.string,
	alsoMatches: PropTypes.arrayOf(PropTypes.object), // array of RegExp
};

NavigationAnchor.defaultProps = {
	alsoMatches: [],
};

export default function NavigationAnchor({ icon, label, linkTo, alsoMatches }) {
	const getNavigationAnchorIcon = () => (
		<>
			<div className={`column-icon icon-${icon}`} />
			<div className="column-text">{label}</div>
		</>
	);

	return (
		<NavigationAnchorRoot
			routes={[linkTo]}
			alsoMatches={alsoMatches}
			icon={icon}>
			{linkTo ? (
				<Link to={linkTo}>{getNavigationAnchorIcon()}</Link>
			) : (
				getNavigationAnchorIcon()
			)}
		</NavigationAnchorRoot>
	);
}
